var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-button',{staticClass:"close-button",attrs:{"suffix":"close-dark","naked":""},on:{"click":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }